import React, { useEffect, useState } from "react";
import { Modal, Row, Col, Input, Alert, Pagination } from "antd";
import { SearchOutlined, LoadingOutlined } from "@ant-design/icons";
import InfiniteScroll from "react-infinite-scroll-component";
import AllGigsFilter from "../../pages/SearchSkillListing/components/AllGigs/AllGigsFilter";
import ChooseGigsButton from "../PlaceBidModal/ChooseGigsButton";
import JobCard from "../JobCard/JobCard";
import { useLocation } from "react-router-dom";
import { ApolloWrapper } from "../ApolloWrapper/ApolloWrapper";
import { DEFAULT_FILTER_VALUES } from "../PlaceBidModal/PlaceBidModal";
import { useLazyQuery } from "@apollo/client";
import { GIGS_QUERY } from "../PlaceBidModal/gigsQuery";
import { useDispatch, useSelector } from "react-redux";
import {
  addBatchMatches,
  fetchMyGigsKeySearchSkills,
  getJobListing,
  keySearchMyGigsLocation,
} from "../../redux/actions";
import { getImageByStateCode } from "../../pages/CompanyProfile/components/cloudinary";
import history from "../../routes/history";
import { useWindowDimensions } from "../../hooks/index";
import _ from "lodash";
import MatchedSkillReducer from "./../../redux/reducers/SkillMacthesReducer";

const ChooseGigPage = ({
  handleSelectedGigDetails = () => {},
  backHandler = () => {
    history.goBack();
  },
  ...props
}) => {
  const { width, height } = useWindowDimensions();
  const { state } = useLocation();
  const dispatch = useDispatch();
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const { batchMatchLoading } = useSelector(
    (state) => state.MatchedSkillReducer
  );
  const [getGigs, { loading: loadingGigs, error, data }] =
    useLazyQuery(GIGS_QUERY, { fetchPolicy: "no-cache", nextFetchPolicy: "no-cache" });
  const [searchFilters, setSearchFilters] = useState({
    ...DEFAULT_FILTER_VALUES,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalGigs, setTotalGigs] = useState(0);
  const searchPublish = data?.gigs?.data || [];
  const [selectedGigDetails, setSelectedGigDetails] = useState();
  const [searchText, setSearchText] = useState("");
  const [gigAlert, setGigAlert] = useState(false);
  const [GigType, setGigType] = useState(false);

  const fetchMoreData = (value) => {};

  const updateFilters = (data) => {
    const params = {
      value: "",
      body: {
        isPrivateGig: GigType,
        ...data,
        MygigsProfileId: userProfile?.MasterAccountId || userProfile?.AccountId,
        JobOrderStatusName: "Published",
      },
    };
    dispatch(keySearchMyGigsLocation(params));
    dispatch(fetchMyGigsKeySearchSkills(params));
  };
  const handleSearch = _.debounce((value) => {
    handleApplyFilter({ ...searchFilters, all: value, search: value });
    updateFilters({ ...searchFilters, all: value, search: value });
  }, 600);

  const searchHandler = (seacrhText) => {
    setCurrentPage(1);
    setSearchText(seacrhText);
    handleSearch(seacrhText);
  };

  const handleApplyFilter = (filters = {}) => {
    setSearchFilters(filters);
    setCurrentPage(1);
    try {
      const {
        all,
        cities,
        countries,
        regions,
        Skills,
        explevel,
        isPrivateGig,
        JobOrderTypeName,
        vms,
        facility,
        _sort,
      } = filters;
      getGigs({
        variables: {
          all: all || "",
          cities: cities?.length ? cities : undefined,
          countries: countries?.length ? countries : undefined,
          regions: regions?.length ? regions : undefined,
          Skills: Skills?.length ? Skills : undefined,
          isPrivateGig,
          MygigsProfileId:
            userProfile?.MasterAccountId || userProfile?.AccountId,
          SkillListingId: props?.userSKillListing?.skill_listings
            ?.SkillListingId
            ? props?.userSKillListing?.skill_listings?.SkillListingId
            : undefined,
          _page: currentPage.toString(),
          _perPage: 6,
          _sort: _sort || "MOST_RECENT",
          explevel: explevel || undefined,
          JobOrderTypeName: JobOrderTypeName || undefined,
          JobOrderStatusName: "Published",
          vms: vms?.length ? vms : undefined,
          facilityIds: facility?.length ? facility : undefined,
        },
      });
    } catch (error) {
      console.warn("error", error);
    }
  };

  const addBatchMatch = () => {
    try {
      dispatch(
        addBatchMatches({
          SkillListingIds: state?.skillListingIds,
          GigId: selectedGigDetails?.JobOrderId,
          callBack: successCallBack,
        })
      );
    } catch (error) {}
  };

  const successCallBack = () => {
    localStorage.removeItem("SelectedSkillsSearch");
    backHandler();
  };

 
  useEffect(() => {
    const {
      all,
      cities,
      countries,
      regions,
      Skills,
      explevel,
      isPrivateGig: filterIsPrivateGig,
      JobOrderTypeName,
      vms,
      facility,
      _sort,
    } = searchFilters;
    getGigs({
      variables: {
        all: all || "",
        cities: cities?.length ? cities : undefined,
        countries: countries?.length ? countries : undefined,
        regions: regions?.length ? regions : undefined,
        Skills: Skills?.length ? Skills : undefined,
        isPrivateGig: filterIsPrivateGig ?? GigType ?? false,
        MygigsProfileId: userProfile?.MasterAccountId || userProfile?.AccountId,
        SkillListingId: props?.userSKillListing?.skill_listings
          ?.SkillListingId
          ? props?.userSKillListing?.skill_listings?.SkillListingId
          : undefined,
        _page: currentPage.toString(),
        _perPage: 6,
        _sort: _sort || "MOST_RECENT",
        explevel: explevel || undefined,
        JobOrderTypeName: JobOrderTypeName || undefined,
        JobOrderStatusName: "Published",
        vms: vms?.length ? vms : undefined,
        facilityIds: facility?.length ? facility : undefined,
      },
    });
  }, [currentPage]);
  useEffect(() => {
    if (data) {
      setTotalGigs(data?.gigs?.aggregate?.totalCount || 0);
    }
  }, [data]);

  return (
    <div className="ChooseGig-cantainer-pvt-tal">
      <div className="ChooseGig-Title-pvt">Choose a job</div>
      <div className="ChooseGig-Section-pvt">
        <Row>
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Input
              className="chooseJobSearch-placeBid"
              style={{
                width: width > 845 && "330px",
                marginLeft: width > 845 && "20px",
              }}
              placeholder="Job title..."
              value={searchText}
              prefix={<SearchOutlined className="joblisting-searchicon" />}
              onChange={(e) => searchHandler(e.target.value)}
              allowClear
            />
          </Col>
        </Row>
        <AllGigsFilter
          setGigType={setGigType}
          GigType={GigType}
          searchText={searchText}
          handleApplyFilter={handleApplyFilter}
          windowDimensions={{ width, height }}
          searchFilters={searchFilters}
          setSearchFilters={setSearchFilters}
          defaultParams={{ JobOrderStatusName: "Published" }}
          isDropdownClose={true}
        />
        <Row>
          {loadingGigs ? (
            <div className="loader-container">
              <LoadingOutlined className="loader" />
            </div>
          ) : searchPublish?.length !== 0 ? (
            searchPublish?.map((item, index) => {
              if (
                item.JobOrderStatuses?.JobOrderStatusName !== "Deleted" &&
                item.JobOrderStatuses?.JobOrderStatusName !== "Expired" &&
                item.JobOrderStatuses?.JobOrderStatusName !== "Closed"
              ) {
                return (
                  <Col
                    key={index}
                    xs={24}
                    sm={12}
                    md={8}
                    lg={8}
                    xl={8}
                    onClick={() => {
                      if (item.isDisabled) return;
                      handleSelectedGigDetails(item);
                      setSelectedGigDetails(item);
                    }}
                  >
                    <div
                      className={`jobcard-container ${
                        selectedGigDetails?._id === item?._id
                          ? "ChooseGig-selected-card-pvt"
                          : null
                      } ${
                        item.isDisabled ? "jobcard-container-disabled" : null
                      }`}
                    >
                      <JobCard
                        {...item}
                        key={item?.JobOrderId}
                        img={
                          item?.Regions?.Code !== null &&
                          item?.Cities?.CityName !== null
                            ? getImageByStateCode(
                                item?.Regions?.Code,
                                item?.Cities?.CityName,
                                item?.CompanyName
                              )
                            : ""
                        }
                        budgetType={item?.BudgetTypes?.BudgetTypeCode}
                        RegionCode={item?.Regions?.Code}
                        CityName={item?.Cities?.CityName}
                        id={item?.JobOrderId}
                        location={item.Location?.LocationWithCountry}
                        title={item?.Title}
                        facilityname={item?.FacilityName}
                        budget={item?.BudgetMin}
                        rate={item?.BudgetTypes?.BudgetTypeName}
                        cardFooter={false}
                        cardFooterChoose={true}
                        fromDashboard={true}
                        professionCode={
                          props.professionCode?.Professions?.ProfessionCode
                        }
                        rating={item?.facilityRating?.rating}
                        WorkplacePolicy={item?.WorkplacePolicy}
                        created={item?.Created}
                        matchedbids={item?.status?.[2]?.count}
                        placedbids={item?.status?.[0]?.count}
                        receivedbids={item?.status?.[1]?.count}
                        isPrivate={item?.isPrivate}
                        vms={item?.VMS}
                      />
                    </div>
                  </Col>
                );
              }
            })
          ) : (
            <div className="emptyOtherSearch">
              <div className="employer-profile-body">
                <div
                  className="employer-profile-body-content"
                  style={{ margin: "10px" }}
                >
                  <img className="nojobimage" src={props.noJobs} />
                  <div className="nojobtext">
                    Create a job to let candidates know you're hiring!
                  </div>
                  <button
                    className="postajob-btn"
                    onClick={() => history.push("/postjob")}
                  >
                    <span className="postjobbtn_plussign">+</span>
                    <span className="postjobbtn_text">Post a job</span>
                  </button>
                </div>
              </div>
            </div>
          )}
        </Row>
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <Pagination
            current={currentPage}
            pageSize={6}
            total={totalGigs}
            onChange={(page) => setCurrentPage(page)}
            showSizeChanger={false}
          />
        </div>
      </div>
      <div className="ChooseGigsButton-btn">
        <ChooseGigsButton
          nextHandler={addBatchMatch}
          backHandler={backHandler}
          selectedGigDetails={selectedGigDetails}
          nextButton="Add to matches"
          nextLoading={batchMatchLoading}
        />
      </div>
    </div>
  );
};

const WrappedChooseGigPage = (props) => (
  <ApolloWrapper>
    <ChooseGigPage {...props} />
  </ApolloWrapper>
);
export default WrappedChooseGigPage;
